import Vue from "vue";
import Router from "vue-router";


import Hiburan from "./views/Hiburan/hiburan.vue"
import EsptpdHiburan from "./views/Hiburan/sptpd/index"
import PembayaranHiburan from "./views/Hiburan/pembayaran/index"

import Reklame from "./views/Reklame/reklame.vue"
import ReklamePendataan from "./views/Reklame/sptpd/index"
import ReklamePembayaran from "./views/Reklame/pembayaran/index"

// walet
import Walet from "./views/walet/walet.vue"
import Esptpd from "./views/walet/sptpd/index"
import Pembayaran from "./views/walet/pembayaran/index"

import AirTanah from "./views/airtanah/airtanah.vue"
import AirTanahPendataan from "./views/airtanah/sptpd/index"
import AirTanahPembayaran from "./views/airtanah/pembayaran/index"

import Mblb from "./views/mblb/mblb.vue"
import EsptpdMblb from "./views/mblb/sptpd/index"
import MblbPembayaran from "./views/mblb/pembayaran/index"

import Ppj from "./views/ppj/ppj.vue"
import EsptpdPPj from "./views/ppj/sptpd/index"
import PpjPembayaran from "./views/ppj/pembayaran/index"

import Parking from "./views/parking/parking.vue"
import EsptpdParking from "./views/parking/sptpd/index"
import PembayaranParking from "./views/parking/pembayaran/index"
import Sop from "./views/Sop"
import SIPP from "./views/Sipp"

// auth
import ResetPassword from './views/auth/ResetPassword'
import ResetPasswordToken from './views/auth/ResetPasswordToken'


Vue.use(Router);

export default new Router({
    linkExactActiveClass: "active",
    routes: [{
            path: "/",
            redirect: { name: 'landing' }
        },
        {
            path: "/landing",
            name: "landing",
            components: {
                header: () => import("./layout/AppHeader"),
                default: () => import("./views/Landing.vue"),
                footer: () => import("./layout/AppFooter"),
            }
        },
        
    {
        path: "/pbb",
        name: "pbb",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbb/pbb.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb",
        name: "bphtb",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/Landing.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb/daftar",
        name: "bphtb_daftar",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/daftar.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb/pengurangan",
        name: "bphtb_pengurangan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/permohonan_kekurangan"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb/from-daftar",
        name: "from_bphtb_daftar",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/form_inline.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb/from-update/:id",
        name: "from_bphtb_update",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/form_inline.vue"),
            footer: () => import("./layout/AppFooter"),
        },
        props: true,

    },
    {
        path: "/pajak-lainnya",
        name: "PajakLainnya",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/PajakLainnya.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Login.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/register",
        name: "register",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Register.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/update-profile",
        name: "updateProfile",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Register.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/verification/:token",
        name: "verification",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/auth/VerificationToken.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/profile",
        name: "profile",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Profile.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hotel",
        name: "Hotel",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Hotel/hotel.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hotel/e-sptpd",
        name: "HotelESptpd",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Hotel/sptpd/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hotel/pembayaran",
        name: "HotelPembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Hotel/pembayaran/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/restoran",
        name: "Restoran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Restoran/restoran.vue"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/restoran/e-sptpd",
        name: "EsptpdRestoran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Restoran/sptpd/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/restoran/pembayaran",
        name: "PembayaranRestoran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/Restoran/pembayaran/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hiburan",
        name: "Hiburan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Hiburan,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hiburan/e-sptpd",
        name: "EsptpdHiburan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: EsptpdHiburan,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/hiburan/pembayaran",
        name: "PembayaranHiburan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: PembayaranHiburan,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/reklame",
        name: "Reklame",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Reklame,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/reklame/pendataan",
        name: "ReklamePendataan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: ReklamePendataan,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/reklame/pembayaran",
        name: "ReklamePembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: ReklamePembayaran,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/burung-walet",
        name: "Walet",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Walet,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/burung-walet/e-sptpd",
        name: "WaletEsptpd",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Esptpd,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/burung-walet/pembayaran",
        name: "WaletPembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Pembayaran,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/air-tanah",
        name: "AirTanah",
        components: {
            header: () => import("./layout/AppHeader"),
            default: AirTanah,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/air-tanah/pendataan",
        name: "AirTanahPendataan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: AirTanahPendataan,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/air-tanah/pembayaran",
        name: "AirTanahPembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: AirTanahPembayaran,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/mineral-bukan-logam-batuan",
        name: "Mblb",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Mblb,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/mineral-bukan-logam-batuan/e-sptpd",
        name: "EsptpdMblb",
        components: {
            header: () => import("./layout/AppHeader"),
            default: EsptpdMblb,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/mineral-bukan-logam-batuan/pembayaran",
        name: "MblbPembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: MblbPembayaran,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-penerangan-jalan",
        name: "Ppj",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Ppj,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-penerangan-jalan/e-sptpd",
        name: "EsptpdPPj",
        components: {
            header: () => import("./layout/AppHeader"),
            default: EsptpdPPj,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-penerangan-jalan/pembayaran",
        name: "PpjPembayaran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: PpjPembayaran,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/parking",
        name: "Parking",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Parking,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/parking/e-sptpd",
        name: "EsptpdParking",
        components: {
            header: () => import("./layout/AppHeader"),
            default: EsptpdParking,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/parking/pembayaran",
        name: "PembayaranParking",
        components: {
            header: () => import("./layout/AppHeader"),
            default: PembayaranParking,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/sop",
        name: "Sop",
        components: {
            header: () => import("./layout/AppHeader"),
            default: Sop,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/sipp",
        name: "SIPP",
        components: {
            header: () => import("./layout/AppHeader"),
            default: SIPP,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        components: {
            header: () => import("./layout/AppHeader"),
            default: ResetPassword,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/reset-password/:token",
        name: "ResetPasswordToken",
        components: {
            header: () => import("./layout/AppHeader"),
            default: ResetPasswordToken,
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/objek-pajak",
        name: "ObjekPajak",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/ObjekPajak/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/objek-pajak/hubungkan-npwpd",
        name: "HubungkanNPWPD",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/ObjekPajak/hubungkanNpwpd"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/objek-pajak/list-npwpd",
        name: "ListNPWPD",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/ObjekPajak/listNpwpd"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/objek-pajak/pendaftaran/create",
        name: "CreateNPWPD",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/ObjekPajak/formDaftar"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/objek-pajak/pendaftaran/update/:id",
        name: "UpdateNPWPD",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/ObjekPajak/formDaftar"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu",
        name: "Pbjt",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu/hotel",
        name: "PbjtHotel",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/hotel"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu/restoran",
        name: "PbjtRestoran",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/restoran"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu/hiburan",
        name: "PbjtHiburan",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/hiburan"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu/parkir",
        name: "PbjtParkir",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/parkir"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pajak-barang-dan-jasa-tertentu/tenaga-listrik",
        name: "PbjtTenagaListrik",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/pbjt/TenagaListrik"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pelaporan-pajak",
        name: "PelaporanPajak",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/PelaporanPajak/index"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/pelaporan-pajak/create/:year/:month",
        name: "PelaporanPajakInput",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/PelaporanPajak/form"),
            footer: () => import("./layout/AppFooter"),
        }
    },
    {
        path: "/bphtb/pelaporan-pajak",
        name: "BPHTBPelaporanPajak",
        components: {
            header: () => import("./layout/AppHeader"),
            default: () => import("./views/bphtb/pelaporan"),
            footer: () => import("./layout/AppFooter"),
        }
    }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});